// extracted by LIB_CSS_EXTRACT_LOADER
import "./card-skeleton_module.css"
export default {"card":"card-PF_RGl","header":"header-eU4IuT","title":"title-uRC85N","subtitle":"subtitle-jB9ys5","content":"content-IqhyQe","line":"line-k7t5i5","lineShort":"lineShort-WRZbwC","footer":"footer-EkTk3S","button":"button-w7787H"};